import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { Row, Heading, InitialAvatarIcon } from '@warrenbrasil/nebraska-web';

import { ITemplateBenefitsData } from './types';

interface Props {
  data: ITemplateBenefitsData;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TemplateBenefits',
  props: {
    data: null
  },
  setup(__props: any) {

const props = __props as {
  data: ITemplateBenefitsData;
}



const title = computed(() => {
  return props.data?.title || '-';
});

return { __sfc: true,props, title, Row, Heading, InitialAvatarIcon }
}

})